import ChallengeDelete from './ChallengeDelete';

export default ChallengeDelete;
